// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
export const StoneGradeFragmentDoc = gql`
    fragment stoneGrade on StoneGrade {
  systemCode
  translation(locale: $locale) {
    name
  }
}
    `;